export default __webpack_public_path__ + "static/media/open.01c0ea7d.svg";